import {Text1} from "../../../../styles/business-components";
import * as S from './styles'

export const Rates = () => {
    return (
        <S.Container>
            <S.Title>Тарифы</S.Title>
            <Text1>
                Представляем вашему вниманию ключевые особенности и преимущества нашего сервиса,
                которые делают его незаменимым инструментом для вашего бизнеса и общения.
            </Text1>

            <S.Grid>
                <S.CellAccent style={{gridArea: '1 / 1 / 1 / 1'}}>Teleguard bussines</S.CellAccent>
                <S.CellAccent style={{gridArea: '1 / 2 / 1 / 2'}}>Basic</S.CellAccent>
                <S.CellAccent style={{gridArea: '1 / 3 / 1 / 3'}}>PRO</S.CellAccent>
                <S.CellAccent style={{gridArea: '1 / 4 / 1 / 4'}}>ENTERPRISE</S.CellAccent>

                <S.Cell style={{gridArea: '2 / 1 / 2 / 1'}}>Автообновление</S.Cell>
                <S.CellAccent style={{gridArea: '2 / 2 / 2 / span 3'}}>
                    <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M29.6005 0.705661C30.1332 1.23834 30.1332 2.10198 29.6005 2.63466L10.9407 21.2944C10.408 21.8271 9.54439 21.8271 9.01171 21.2944L0.399508 12.6822C-0.133169 12.1496 -0.133169 11.2859 0.399508 10.7532C0.932186 10.2206 1.79583 10.2206 2.32851 10.7532L9.97621 18.4009L27.6715 0.705661C28.2042 0.172983 29.0678 0.172983 29.6005 0.705661Z" fill="#00637B"/>
                    </svg>
                </S.CellAccent>

                <S.Cell style={{gridArea: '3 / 1 / 3 / 1'}}>Видеоконференции</S.Cell>
                <S.CellAccent style={{gridArea: '3 / 2 / 3 / 2'}}>20</S.CellAccent>
                <S.CellAccent style={{gridArea: '3 / 3 / 3 / 3'}}>50</S.CellAccent>
                <S.CellAccent style={{gridArea: '3 / 4 / 3 / 4'}}>{'>'}100</S.CellAccent>

                <S.Cell style={{gridArea: '4 / 1 / 4 / 1'}}>Объем диска</S.Cell>
                <S.CellAccent style={{gridArea: '4 / 2 / 4 / 2'}}>250 GB</S.CellAccent>
                <S.CellAccent style={{gridArea: '4 / 3 / 4 / 3'}}>1 TB</S.CellAccent>
                <S.CellAccent style={{gridArea: '4 / 4 / 4 / 4'}}>500 GB</S.CellAccent>

                <S.Cell style={{gridArea: '5 / 1 / 5 / 1'}}>Время хранения данных</S.Cell>
                <S.CellAccent style={{gridArea: '5 / 2 / 5 / 2'}}>30 Дней</S.CellAccent>
                <S.CellAccent style={{gridArea: '5 / 3 / 5 / span 2'}}>
                    <svg width="34" height="18" viewBox="0 0 34 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3045 6C13.3501 4.97228 12.2191 4.01848 10.722 3.21795C8.58812 2.07695 6.85477 2.20813 4.77888 3.21795C0.627093 5.23758 0.627093 12.7624 4.77888 14.782C6.85477 15.7918 9.16504 15.9231 10.722 14.782C16.0112 10.9053 16.8252 6.3102 22.6081 3.21795C24.742 2.07695 26.4753 2.20813 28.5512 3.21795C32.703 5.23758 32.703 12.7624 28.5512 14.782C26.4753 15.7918 24.742 15.9231 22.6081 14.782C21.1112 13.9815 19.9802 13.0277 19.0258 12" stroke="#00637B" stroke-width="3" stroke-linejoin="round"/>
                    </svg>
                </S.CellAccent>

                <S.Cell style={{gridArea: '6 / 1 / 6 / 1'}}>Отклик тех. поддержки</S.Cell>
                <S.CellAccent style={{gridArea: '6 / 2 / 6 / 2'}}>24 часа</S.CellAccent>
                <S.CellAccent style={{gridArea: '6 / 3 / 6 / 3'}}>6 часов</S.CellAccent>
                <S.CellAccent style={{gridArea: '6 / 4 / 6 / 4'}}>12 часов</S.CellAccent>

                <S.Cell style={{gridArea: '7 / 1 / 7 / 1'}}>Функционал админки</S.Cell>
                <S.CellAccent style={{gridArea: '7 / 2 / 7 / 2'}}>standard</S.CellAccent>
                <S.CellAccent style={{gridArea: '7 / 3 / 7 / 3'}}>premium</S.CellAccent>
                <S.CellAccent style={{gridArea: '7 / 4 / 7 / 4'}}>expanded</S.CellAccent>
            </S.Grid>
        </S.Container>
    );
}